module.exports = __webpack_public_path__ + "static/media/Mario_German_Fromow_Rangel.714f03a4.jpg";